<style>    
    .product-deals-container .product-image{
        height: 40px;
        width: 40px;
        object-fit: cover;
        border-radius: 4px;
        border-radius: 4px;
    }
    .product-deal-item .text-truncate{
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 178px;
        display: block;
    }
    .product-deal-item{
        border-bottom: 1px solid var(--border-color-1);
        font-size: 14px;
        padding: 10px 0px;
    }
</style>

<script>
    import {shopifyHelperMixin} from "../../mixins/shopifyHelperMixin";

    export default {
        props: ['products'],
        components: {

        },
        mixins: [shopifyHelperMixin],
        data: function () {
            return {
                confirm_delete: false,
                deleting: false
            }
        },
        computed: {
            
        },
        created: function () {

        },
        mounted: function () {

        },
        methods: {
            getPreviousPrice: function(product){
                var previous_price;
                if(product.price_history && product.price_history.length){
                    previous_price = product.price_history[product.price_history.length - 1].unit_price;
                } else if(product.last_price_change < 0){
                    previous_price = product.unit_price / (1 + product.last_price_change / 100);
                }
                if(previous_price){
                    previous_price = this.$options.filters.formatCurrency(previous_price);
                }
                return previous_price;
            },
        }
    };

</script>

<template>
    <div class="product-deals-container">
        <a :href="product.profile_url" class="text-reset row row-sm align-items-center product-deal-item flex-nowrap" v-for="product in products">
            <div class="col-auto" v-if="product.images.length">
                <img class="product-image" :src="resizeImage(product.images[0].src, '_64x')" onerror="this.onerror=null;this.src='/img/product_placeholder.png';">
            </div>
            <div class="col">
                <span class="text-truncate" :title="product.title">{{product.title}}</span>
                <span class="text-truncate text-subtle fs-12" v-if="product.shop" :title="product.shop.name">
                    {{product.shop.name}}
                </span>
            </div>
            <div class="col-auto" style="width: 70px">
                <span class="text-subtle text-decoration-line-through">
                    {{getPreviousPrice(product)}}
                </span>
            </div>
            <div class="col-auto text-danger" style="width: 60px">{{product.unit_price | formatCurrency}}</div>
        </a>
    </div>
</template>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/shop/bestDeals.vue